export const loaderPages = {
  ENTITY_PROPERTIES: "entity_properties",
  HOME_OVERVIEW: "home_overview",
  HOME_ANALYTICS: "home_analytics",
  HOME_ACTIVITY: "home_activity",
  DETAIL: "detail",
  EMAIL: "email",
  BILLING_PROMPT: "billing_prompt",
  CONVERSATION_LEFT_PANEL: "conversation_left_panel",
  CONVERSATION_RIGHT_PANEL: "conversation_right_panel",
  CONVERSATION_RIGHT_PANEL_LIST: "conversation_right_panel_list",
  OUTREACH_RESEARCH: "outreach_research",
  ONBOARDING: "onboarding",
  GET_STARTED: "get_started",
  PROFILE_ICON: "profile_icon",
  TABLE: "table",
  CHART: "chart",
  GENERATE_NUMBER: "generate_number",
  CALL_DETAILS: "call_details",
  CALL_CAMPAIGN_ENTITIES: "call_campaign_entities",
  CONTAINER_INFO_ITEM: "contact_info_item",
  ANALYTICS: "analytics",
  ANALYTICS_CHART_TABLE: "charts_table",
  WORKSPACE_SECTION: "workspace_section",
  AUDIO_PLAYER: "audio_player",
  NAV_LIST: "nav_list",
  CALL_LOG_DETAILS: "call_log_details",
  CALL_LOG_RECORDING_AND_TRANSCRIPT: "call_log_recording_and_transcript",
  ENTITY_DETAILS: "entity_details",
  SALESFORCE_SYNC: "salesforce_sync",
  HUBSPOT_SYNC: "hubspot_sync",
  UPDATE_CALL_ROUTE: "update_call_route",
  TRANSFER_CALL: "transfer_call",
  INFO_ITEM: "info_item",
  DIALER: "dialer",
  CALL_PARTICIPANTS: "call_participants",
  CALL_CAMPAIGN_CREATE: "call_campaign_create",
  CALL_CAMPAIGN_EDIT: "call_campaign_edit",
  VOICE_AGENT_CAMPAIGN_CREATE: "voice_agent_campaign_create",
  VOICE_AGENT_CAMPAIGN_EDIT: "voice_agent_campaign_edit",
  CAMPAIGN_VIEW_DETAILS: "call_campaign_view_details",
  NUMBER_SUBMISSION_STATUS: "call_submission_status",
  MANAGE_BUSINESS_SUBMISSION: "manage_business_submission",
  ENTITY_SCORING: "entity_scoring",
  EMAIL_ACTIVITY: "email_activity",
  MEETING_RECORDING: "meeting_recording",
  MEETING_SUMMARY: "meeting_summary",
  MEETING_INTELLIGENCE: "meeting_intelligence",
  AUDIT_TRAIL: "audit_trail",
  VALIDATION_MODAL: "validation_modal",
  SENDER_DETAILS_MODAL: "sender_details_modal",
  EMAIL_PREVIEW: "email_preview",
  EMAIL_CAMPAIGN_CREATE: "email_campaign_create",
  WATERFALL: "waterfall",
  INBOUND_AGENT_INBOX: "inbound_agent_inbox",
  KNOWLEDGE_BASE: "knowledge_base",
  INSTRUCTIONS: "instructions",
  LIVE_CHAT_WIDGET: "live_chat_widget",
  INBOX_LEFT_PANEL: "inbox_left_panel",
  INBOX_CENTER_PANEL: "inbox_center_panel",
  INBOX_RIGHT_PANEL: "inbox_right_panel",
  UNIBOX_CENTER_PANEL: "unibox_center_panel",
  NUMBER_CHECK: "number_check",
  INBOX_CENTRAL_PANEL_TOP_BAR: "inbox_central_panel_top_bar",
  CHAT_BROWSER_PANEL: "chat_browser_panel",
  CHAT_LIST_ITEM: "chat_list_item",
  CHAT_MESSAGES: "chat_messages",
  FORM_INPUT: "form_input",
  AGI_ASSISTANT_CHAT: "agi_assistant_chat",
  AGI_ASSISTANT_CHAT_MESSAGES: "agi_assistant_chat_messages",
  MANAGE_COLUMNS: "manage_columns",
  ACTIVITY_TAB: "activity_tab",
  PHONE_NUMBER_DETAILS: "phone_number_details",
  SELECT: "select",
  OUTBOUND_SELECT: "outbound_select",
  ADD_TASK_MODAL: "add_task_modal",
  SPACES_PANEL: "spaces_panel",
  TREE: "tree",
  SUB_OBJECT_MODAL: "sub_object_modal",
  COMPONENT_CARD: "component_card",
  ANALYTICS_EDITOR: "analysis_editor",
  OBJECT_FILTER_SELECTOR: "object_filter_selector",
  VOICE_AGENT_BEHAVIOUR: "voice_agent_behaviour",
  PERMISSION_SECTIONS: "permission_sections",
  PERMISSION_MANAGEMENT: "permission_management",
  ANALYTICS_TEMPLATES: "analytics_templates",
  ANALYTICS_TEMPLATES_VIEW: "analytics_templates_view",
  LIVE_ASSIST_WIDGET: "live_assist_widget",
  REPO_CODE: "repo_code",
};
